import React from "react";
import { BaseComponentWrapper } from "./BaseComponent.styled";
import ContentfulText from "../../components/parts/ContentfulText";
import type { BaseComponentProps } from "../../utils/contentfulBaseComponent";
import { HubbleProvider } from "@hubble/web";
import { componentNames } from "components/pages/Dynamic/ContentfulComponent";
import { ContentfulButton } from "components/parts/ContentfulButton";

export const BaseComponentInner = ({
  text,
  cta,
  styles,
  groupedContent
}: Omit<BaseComponentProps, "theme">) => {
  return (
    <BaseComponentWrapper {...styles}>
      {Boolean(text) && text.map((text) => <ContentfulText {...text} />)}
      {Boolean(cta) && cta.map((cta) => <ContentfulButton {...cta} />)}
      {Boolean(groupedContent) &&
        groupedContent.map((data: BaseComponentProps) => {
          const componentType = data.componentType?.type;
          const Component =
            componentNames.find((data) => data?.value === componentType)
              ?.render || null;
          if (!Component) return null;
          return (
            <React.Fragment key={data.id}>
              <Component {...data} />
            </React.Fragment>
          );
        })}
    </BaseComponentWrapper>
  );
};

export const BaseComponent = ({ theme, ...rest }: BaseComponentProps) => {
  return Boolean(theme) ? (
    <HubbleProvider scheme={theme}>
      <BaseComponentInner {...rest} />
    </HubbleProvider>
  ) : (
    <BaseComponentInner {...rest} />
  );
};
